import { $http } from "./fetch";

/**
 * 会员登录
 */
const login = (data) => {
  return Promise.resolve(
    $http({
      url: "/user/login",
      params: data
    })
  );
};

/**
 * 注册会员
 */
// const feedback = (data) => {
//   return Promise.resolve(
//     $http({
//       url: "/Opinion/insertoOpinion",
//       params: data
//     })
//   );
// };

/**
 * 注册会员
 */
const register = (data) => {
  return Promise.resolve(
    $http({
      url: "/user/register",
      params: data
    })
  );
};

/**
 * 注销登录
 */
const logout = (data) => {
  return Promise.resolve(
    $http({
      url: "/user/logout",
      params: data
    })
  );
};

/**
 * 重置密码
 */
const resetpwd = (data) => {
  return Promise.resolve(
    $http({
      url: "/user/resetpwd",
      params: data
    })
  );
};

/**
 * 发送验证码
 */
const smsSend = (data) => {
  return Promise.resolve(
    $http({
      url: "/sms/send",
      params: data
    })
  );
};

/**
 * 发送验证码
 */
const emsSend = (data) => {
  return Promise.resolve(
    $http({
      url: "/ems/send",
      params: data
    })
  );
};

/**
 * 检测邮箱
 */
const checkEmailAvailable = (data) => {
  return Promise.resolve(
    $http({
      url: "/validate/check_email_available",
      params: data
    })
  );
};

/**
 * 检测用户名
 */
const checkUsernameAvailable = (data) => {
  return Promise.resolve(
    $http({
      url: "/validate/check_username_available",
      params: data
    })
  );
};

/**
 * 检测手机
 */
const checkMobileAvailable = (data) => {
  return Promise.resolve(
    $http({
      url: "/validate/check_mobile_available",
      params: data
    })
  );
};

/**
 * 检测手机
 */
const checkMobileExist = (data) => {
  return Promise.resolve(
    $http({
      url: "/validate/check_mobile_exist",
      params: data
    })
  );
};

/**
 * 检测邮箱
 */
const checkEmailExist = (data) => {
  return Promise.resolve(
    $http({
      url: "/validate/check_email_exist",
      params: data
    })
  );
};

/**
 * 新闻资讯列表 /api/News/list/cat/{cat}
 */
const newsListCat = (data) => {
  return Promise.resolve(
    $http({
      url: "/News/list/cat",
      data
    })
  );
};

/**
 * 新闻资讯分类 /api/News/cases_cat/
 */
const newsCasesCat = (data) => {
  return Promise.resolve(
    $http({
      url: "/News/cases_cat",
      data
    })
  );
};

/**
 * 新闻资讯详情 /api/News/detail/id/{id}
 */
const newsDetail = (data) => {
  return Promise.resolve(
    $http({
      url: "/News/detail/id/",
      data
    })
  );
};

/**
 * 产品列表 /api/Product/list/cat/{cat}
 */
const productList = (data) => {
  return Promise.resolve(
    $http({
      url: "/Product/list/cat/",
      data
    })
  );
};

/**
 * 产品分类 /api/Product/product_cat/
 */
const productCat = (data) => {
  return Promise.resolve(
    $http({
      url: "/Product/product_cat/",
      data
    })
  );
};

/**
 * 产品详情 /api/Product/detail/id/{id}
 */
const productDetail = (data) => {
  return Promise.resolve(
    $http({
      url: "/Product/detail",
      method: "GET",
      params: data
    })
  );
};

/**
 *  关于我们 /api/About/index/
 */
const aboutIndex = (data) => {
  return Promise.resolve(
    $http({
      url: "/About/index/",
      data
    })
  );
};

/**
 *  联系信息 /api/About/contact/
 */
const aboutContact = (data) => {
  return Promise.resolve(
    $http({
      url: "/About/contact/",
      data
    })
  );
};

/**
 *  首页 /api/index/index
 */
const index = (data) => {
  return Promise.resolve(
    $http({
      url: "/index/index/",
      data
    })
  );
};

/**
 *  首页 /api/Product/catdetail
 */
const catdetail = (data) => {
  return Promise.resolve(
    $http({
      url: "/Product/catdetail",
      params: data
    })
  );
};

/**
 *  软件升级列表 /api/Soft/list
 */
const softList = (data) => {
  return Promise.resolve(
    $http({
      url: "/Soft/list",
      params: data
    })
  );
};

/**
 *  软件升级信息详情 /api/Soft/detail/id/{id}
 */
const softDetail = (data) => {
  return Promise.resolve(
    $http({
      url: "/Soft/detail",
      params: data
    })
  );
};

/**
 *  搜索列表 /api/Soft/search/str/{str}
 */
const softSearch = (data) => {
  return Promise.resolve(
    $http({
      url: "/Soft/search",
      params: data
    })
  );
};

/**
 * ⻢上升级接口: /api/Softorder/create?userid=1111&sn=MOTO1901001-31BDFA 返回支付类型和支付金额
 */
const softorderCreate = (data) => {
  return Promise.resolve(
    $http({
      url: "/Softorder/create",
      params: data
    })
  );
};

/**
 * 支付接口:/api/Softorder/orderpay?userid=1111&type=wx&orderno=MST545345634543
 * 返回支付信息 如果订单金额为0，为不用支付，直接返回code=8888和downloadPath
 */
const softorderOrderpay = (data) => {
  return Promise.resolve(
    $http({
      url: "/Softorder/orderpay",
      params: data
    })
  );
};

/**
 * 检查支付状态 /api/Softorder/checkOrder?userid=1111&orderno=MST545345634543
 * 返回下载地址downloadPath 订单未支付，返回错误信息
 */
const softorderCheckOrder = (data) => {
  return Promise.resolve(
    $http({
      url: "/Softorder/checkOrder",
      params: data
    })
  );
};

/**
 * 表单选择数据接口: https://wp.maoban.net/api/Category/all返回所有层级数据
 */
const categoryAll = (data) => {
  return Promise.resolve(
    $http({
      url: "/Category/all",
      params: data
    })
  );
};

/**
 * 搜索接口https://wp.maoban.net/api/Category/search
 * 例子: https://wp.maoban.net/api/Category/search?ehicleBrand=%E6%98%A5%E9%A3%8E%E6%91%A9%E6%89%98&year=2019&vehicleType =400GT&eSystem=ABS&ecuType=%E5%8D%9A%E4%B8%96(Bosch)MSE6.0&tCode=P0031
 * 返回文字信息和pdf下载链接
 */
const categorySearch = (data) => {
  return Promise.resolve(
    $http({
      url: "/Category/search",
      params: data
    })
  );
};

/**
 * 修改邮箱 /api/user/changeemail
 */
const changeemail = (data) => {
  return Promise.resolve(
    $http({
      url: "/user/changeemail",
      params: data
    })
  );
};

/**
 * 修改手机号 /api/user/changemobile
 */
const changemobile = (data) => {
  return Promise.resolve(
    $http({
      url: "/user/changemobile",
      params: data
    })
  );
};

/**
 * 用户增加设备号SN /api/user/addSN
 */
const addSN = (data) => {
  return Promise.resolve(
    $http({
      url: "/user/addSN",
      params: data
    })
  );
};

/**
 * 用户搜索设备号SN /api/user/searchSN
 */
const searchSN = (data) => {
  return Promise.resolve(
    $http({
      url: "/user/searchSN",
      params: data
    })
  );
};

/**
 * 用户设备号记录 /api/user/userSN
 */
const userSN = (data) => {
  return Promise.resolve(
    $http({
      url: "/user/userSN",
      params: data
    })
  );
};

/**
 * 用户设备马上升级 /api/Softorder/upgradable
 */
const upgradable = (data) => {
  return Promise.resolve(
    $http({
      url: "/Softorder/upgradable",
      params: data
    })
  );
};

/**
 * 用户订单记录 /api/user/userSoftOrder
 */
const userSoftOrder = (data) => {
  return Promise.resolve(
    $http({
      url: "/user/userSoftOrder",
      params: data
    })
  );
};

/**
 * 所有顶部图片 /api/Topimg/all
 */
const topingAll = (data) => {
  return Promise.resolve(
    $http({
      url: "/Topimg/all",
      method: "GET",
      params: data
    })
  );
};

/**
 * 维修手册列表 /api/Motomanual/list
 */
const motomanualList = (data) => {
  return Promise.resolve(
    $http({
      url: "/Motomanual/list",
      params: data
    })
  );
};

/**
 * 维修手册信息详情 /api/Motomanual/detail/id/{id}
 */
const motomanualDetail = (data) => {
  return Promise.resolve(
    $http({
      url: "/Motomanual/detail/id/",
      params: data
    })
  );
};

/**
 * 搜索列表 /api/Motomanual/search/str/{str}
 */
const motomanualSearch = (data) => {
  return Promise.resolve(
    $http({
      url: "/Motomanual/search/str/",
      params: data
    })
  );
};

/**
 * 维修视频列表 /api/Motovideo/list
 */
const motovideoList = (data) => {
  return Promise.resolve(
    $http({
      url: "/Motovideo/list",
      params: data
    })
  );
};

/**
 * 维修视频信息详情 /api/Motovideo/detail/id/{id}
 */
const motovideoDetail = (data) => {
  return Promise.resolve(
    $http({
      url: "/Motovideo/detail/id/",
      params: data
    })
  );
};

/**
 * 搜索列表 /api/Motovideo/search/str/{str}
 */
const motovideoSearch = (data) => {
  return Promise.resolve(
    $http({
      url: "/Motovideo/search/str/",
      params: data
    })
  );
};

/**
 * 分类列表:http://mst.maoban.net/api/Motomanual/motomanual_cat/?lang=zh
 */
const motomanualCat = (data) => {
  return Promise.resolve(
    $http({
      url: "/Motomanual/motomanual_cat",
      params: data
    })
  );
};

/**
 * 分类手册列表(POST):http://mst.maoban.net/api/Motomanual/list/cat/?lang=zh
 * 数据：cat=67&page=1&limit=100
 */
const motomanualListCat = (data) => {
  return Promise.resolve(
    $http({
      url: "/Motomanual/list/cat/",
      params: data
    })
  );
};

/**
 * 分类列表:http://mst.maoban.net/api/Motovideo/motomanual_cat/?lang=zh
 */
const motovideoCat = (data) => {
  return Promise.resolve(
    $http({
      url: "/Motovideo/motovideo_cat",
      params: data
    })
  );
};

/**
 * 分类手册列表(POST):http://mst.maoban.net/api/Motovideo/list/cat/?lang=zh
 * 数据：cat=67&page=1&limit=100
 */
const motovideoListCat = (data) => {
  return Promise.resolve(
    $http({
      url: "/Motovideo/list/cat",
      params: data
    })
  );
};

/**
 * 维修说明书分类 /api/Synopsis/Synopsis_cat/
 */
const synopsisCat = (data) => {
  return Promise.resolve(
    $http({
      url: "/Synopsis/Synopsis_cat",
      params: data
    })
  );
};

/**
 * 维修说明书列表 /api/Synopsis/list/cat/{cat}
 * 数据：cat=67&page=1&limit=100
 */
const synopsisListCat = (data) => {
  return Promise.resolve(
    $http({
      url: "/Synopsis/list/cat",
      params: data
    })
  );
};

/**
 * 维修说明书信息详情 /api/Synopsis/detail/id/{id}
 */
const synopsisDetail = (data) => {
  return Promise.resolve(
    $http({
      url: "/Synopsis/detail/id/",
      params: data
    })
  );
};

export default {
  login,
  register,
  // feedback,
  logout,
  resetpwd,
  smsSend,
  emsSend,
  checkEmailAvailable,
  checkUsernameAvailable,
  checkMobileAvailable,
  checkMobileExist,
  checkEmailExist,
  newsListCat,
  newsCasesCat,
  newsDetail,
  productList,
  productCat,
  productDetail,
  aboutIndex,
  aboutContact,
  index,
  catdetail,
  softList,
  softDetail,
  softSearch,
  softorderCreate,
  softorderOrderpay,
  softorderCheckOrder,
  categoryAll,
  categorySearch,
  changeemail,
  changemobile,
  addSN,
  searchSN,
  userSN,
  upgradable,
  userSoftOrder,
  topingAll,
  motomanualList,
  motomanualDetail,
  motomanualSearch,
  motovideoList,
  motovideoDetail,
  motovideoSearch,
  motomanualCat,
  motomanualListCat,
  motovideoCat,
  motovideoListCat,
  synopsisCat,
  synopsisListCat,
  synopsisDetail
};
